<template>
  <div>
    <div v-if="!showSuccessStep">
        <div class="excel-modal__body" v-if="currentStep === 1">
          <div class="excel-modal__info">
            <span>{{ resource["hrvenue.createcandidate.addCandidateInfoNew"].replace("{count}", sendableCount ?? 1000) }}</span><br/>
            <span v-html="exampleExcellText"></span>
          </div>
          <div class="excel-upload-container">
            <div
              class="excel-dropzone"
              :class="{
                'drag-over': isDragging,
                'has-file': selectedFile,
                'is-invalid': fileError
              }"
              @dragover.prevent="onDragOver"
              @dragleave.prevent="onDragLeave"
              @drop.prevent="onFileDrop"
            >
              <input
                type="file"
                ref="fileInput"
                accept=".xls,.xlsx"
                class="file-input"
                @change="onFileSelected"
              >

              <div v-if="!selectedFile" class="upload-placeholder">
                <div class="upload-icon" v-if="!isDragging">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <mask id="mask0_18693_38162" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect y="0.5" width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_18693_38162)">
                      <path d="M11.25 12.7152L9.91725 14.0328C9.78042 14.1711 9.60933 14.2402 9.404 14.2402C9.19883 14.2402 9.02183 14.1659 8.873 14.0173C8.72817 13.8787 8.65733 13.7032 8.6605 13.4905C8.66383 13.2777 8.73467 13.102 8.873 12.9635L11.3673 10.4693C11.5481 10.2884 11.759 10.198 12 10.198C12.241 10.198 12.4519 10.2884 12.6328 10.4693L15.127 12.9635C15.2653 13.102 15.3387 13.2747 15.347 13.4817C15.3553 13.6887 15.282 13.8675 15.127 14.018C14.9885 14.156 14.8154 14.2259 14.6077 14.2277C14.4001 14.2297 14.2218 14.1615 14.073 14.023L12.75 12.7152V18.1923C12.75 18.2692 12.7821 18.3398 12.8462 18.4038C12.9102 18.4679 12.9808 18.5 13.0577 18.5H18.5C19.2 18.5 19.7917 18.2583 20.275 17.775C20.7583 17.2917 21 16.7 21 16C21 15.3 20.7583 14.7083 20.275 14.225C19.7917 13.7417 19.2 13.5 18.5 13.5H17V11.5C17 10.1167 16.5125 8.9375 15.5375 7.9625C14.5625 6.9875 13.3833 6.5 12 6.5C10.6167 6.5 9.4375 6.9875 8.4625 7.9625C7.4875 8.9375 7 10.1167 7 11.5H6.48075C5.53325 11.5 4.71625 11.8417 4.02975 12.525C3.34325 13.2083 3 14.0333 3 15C3 15.9667 3.34167 16.7917 4.025 17.475C4.70833 18.1583 5.53333 18.5 6.5 18.5H8.25C8.4625 18.5 8.64067 18.5719 8.7845 18.7158C8.92817 18.8596 9 19.0378 9 19.2503C9 19.4629 8.92817 19.641 8.7845 19.7845C8.64067 19.9282 8.4625 20 8.25 20H6.5C5.118 20 3.93917 19.5206 2.9635 18.5617C1.98783 17.6029 1.5 16.4311 1.5 15.0463C1.5 13.8039 1.89967 12.7113 2.699 11.7683C3.49833 10.8253 4.48967 10.2666 5.673 10.0923C5.9935 8.59742 6.74517 7.375 7.928 6.425C9.11067 5.475 10.468 5 12 5C13.8107 5 15.3467 5.63067 16.608 6.892C17.8693 8.15333 18.5 9.68933 18.5 11.5V12H18.8078C19.8616 12.082 20.7404 12.5058 21.4443 13.2713C22.1481 14.0366 22.5 14.9462 22.5 16C22.5 17.1153 22.1154 18.0608 21.3463 18.8365C20.5769 19.6122 19.6346 20 18.5193 20H13.0577C12.5526 20 12.125 19.825 11.775 19.475C11.425 19.125 11.25 18.6974 11.25 18.1923V12.7152Z" fill="#FF8D06"/>
                    </g>
                  </svg>
                </div>
                <div class="upload-text" v-if="!isDragging">
                  <h3>{{ resource['DragAndDrop'] }}</h3>
                  <button
                    type="button"
                    class="btn-select-file"
                    @click="triggerFileInput"
                  >
                    {{ resource['DragAndDropUpload'] }}
                  </button>
                </div>
                <div class="upload-text" v-else>
                  <h3>{{ resource['DragAndDropTitle'] }}</h3>
                </div>
              </div>

              <div v-else class="selected-file">
                <div class="file-icon">
                  <span>{{ selectedFile.name.split('.').pop() }}</span>
                </div>
                <div class="file-details">
                  <p class="file-name">{{ formatFileName(selectedFile.name) }}</p>
                  <p class="file-size">{{ formatFileSize(selectedFile.size) }}</p>
                </div>
                <button class="btn-remove-file" @click="removeFile">
                  <i class="icon-close-rounded"></i>
                </button>
              </div>
            </div>
          </div>
          <p v-if="fileError" class="error-message">{{ fileError }}</p>
          <p v-else-if="!selectedFile" class="info-message">{{ resource['DragAndDropInfo'] }}</p>

          <div class="schedule-area" v-if="interviewType === 1">
            <div class="schedule-area__header">
              <h4>{{ resource['ScheduleAreaTitle'] }}</h4>
              <span>{{ resource['ScheduleAreaDescriptionExcel'] }}</span>
            </div>
            <div class="schedule-area__preview">
              <button
                id="schedule"
                :class="showDatePicker ? null : 'collapsed'"
                :aria-expanded="showDatePicker ? 'true' : 'false'"
                aria-controls="date-collapse"
                @click="handleDatePicker"
              >
                <div class="d-flex align-items-center justify-content-center gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M15.8333 3.33366H15V1.66699H13.3333V3.33366H6.66667V1.66699H5V3.33366H4.16667C3.25 3.33366 2.5 4.08366 2.5 5.00033V16.667C2.5 17.5837 3.25 18.3337 4.16667 18.3337H15.8333C16.75 18.3337 17.5 17.5837 17.5 16.667V5.00033C17.5 4.08366 16.75 3.33366 15.8333 3.33366ZM15.8333 16.667H4.16667V8.33366H15.8333V16.667ZM4.16667 6.66699V5.00033H15.8333V6.66699H4.16667ZM5.83333 10.0003H14.1667V11.667H5.83333V10.0003ZM5.83333 13.3337H11.6667V15.0003H5.83333V13.3337Z"
                      fill="#333333"
                    />
                  </svg>
                  {{
                    localDateRange.startDate &&
                    globalFormatTimeUserLocalWithLang(localDateRange.startDate, language)
                  }}
                  -
                  {{
                    localDateRange.endDate &&
                    globalFormatTimeUserLocalWithLang(localDateRange.endDate, language)
                  }}
                </div>
                <span v-if="!showDatePicker">{{ resource['label.Edit'] }}</span>
                <span v-if="showDatePicker" @click="validateDateInputs">{{ resource['label.Save'] }}</span>
              </button>
            </div>
            <b-collapse id="date-collapse" v-model="showDatePicker">
              <DatePicker
                ref="dateRangePicker"
                v-model="localDateRange"
                @update="handleUpdate"
                :isStartDateFixed="false"
              />
            </b-collapse>
            <!-- <div class="schedule-area__divider"></div> -->
            <b-form-checkbox
                class="checkbox-candidate d-flex align-items-center cursor-pointer"
                id="send-mail-checkbox"
                v-model="sendMail"
            >
              {{ resource['ScheduleAreaSendEmailDescription'] }}
            </b-form-checkbox>
            <!-- <b-form-radio-group
              v-model="sendMail"
              :id="'radio-group-send-mail'"
              class="d-flex flex-column"
            >
              <b-form-radio :value="sendMail"> {{ resource['ScheduleAreaSendEmailDescription'] }} </b-form-radio>
              <b-form-radio :value="!sendMail"> {{ resource['ScheduleAreaNotSendEmailDescription'] }}</b-form-radio>
            </b-form-radio-group> -->
          </div>
          <!-- <div v-if="showDatePickerError" class="error-info-area mt-3">
            <i class="icon-warning-outline"></i>
            <span>{{ resource['ScheduleAreaSelectionError'] }}</span>
            <i class="icon-close-rounded cursor-pointer" @click="showDatePickerError = false"></i>
          </div>
          <div v-if="showDatePickerSaveError" class="error-info-area mt-3">
            <i class="icon-warning-outline"></i>
            <span>{{ resource['ScheduleAreaSelectionSaveError'] }}</span>
            <i class="icon-close-rounded cursor-pointer" @click="showDatePickerSaveError = false"></i>
          </div>
          <div v-if="showDatePickerSuccess" class="success-info-area">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 1.66602C5.4 1.66602 1.66667 5.39935 1.66667 9.99935C1.66667 14.5993 5.4 18.3327 10 18.3327C14.6 18.3327 18.3333 14.5993 18.3333 9.99935C18.3333 5.39935 14.6 1.66602 10 1.66602ZM10 16.666C6.325 16.666 3.33333 13.6743 3.33333 9.99935C3.33333 6.32435 6.325 3.33268 10 3.33268C13.675 3.33268 16.6667 6.32435 16.6667 9.99935C16.6667 13.6743 13.675 16.666 10 16.666ZM13.825 6.31602L8.33333 11.8077L6.175 9.65768L5 10.8327L8.33333 14.166L15 7.49935L13.825 6.31602Z" fill="#19552E"/>
            </svg>
            <span>{{ resource['ScheduleAreaSelectionSuccess'] }}</span>
          </div> -->
        </div>
      <div class="excel-modal__body" v-if="currentStep === 2">
        <div v-if="fileUploadLoading" class="loading-indicator">
          <i class="icon-spinner icon-spin"></i>
          <span>{{ resource['candidateListLoading'] }}</span>
        </div>
        <validation-observer v-slot="{ touched }" v-else>
          <div v-if="showCandidateListErrorMessages" class="error-info-area mt-3">
              <i class="icon-warning-outline"></i>
              <span>{{ resource['Label.GeneralErrorText'] }}</span>
              <i class="icon-close-rounded cursor-pointer" @click="showCandidateListErrorMessages = false"></i>
            </div>
          <div class="excel-modal__sticky-header">
            <div class="search-container">
              <div class="search-info">
                <span>{{ resource['addCandidateModalListInfo'] }}</span>
              </div>
              <div class="search-input-wrapper">
                <input
                  type="text"
                  v-model="searchTerm"
                  :placeholder="resource['addCandidateModalSearchPlaceholder']"
                  class="search-input"
                />
                <div class="search-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#878787" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="interview-input-header">
              <div class="checkbox-column">
                <div class="select-all-checkbox">
                  <b-form-checkbox
                    id="selectAll"
                    class="checkbox-candidate"
                    :checked="isAllSelected"
                    @change="toggleSelectAll"
                  />
                </div>
              </div>
              <div class="input-columns">
                <span>{{ resource['hrvenue.createCandidate.Name'] }}</span>
                <span>{{ resource['hrvenue.createCandidate.Surname'] }}</span>
                <span>{{ resource['hrvenue.createCandidate.Email'] }}</span>
              </div>
            </div>
          </div>
          <div class="candidates-list">
            <div :class="['interview-input-group', touched ? 'touched': '']" v-for="(candidate, indexAt) in visibleCandidates" :key="indexAt">
              <div class="candidate-checkbox">
                <b-form-checkbox
                  class="checkbox-candidate"
                  :id="`candidate-${indexAt}`"
                  :checked="isSelected(candidate)"
                  @change="toggleSelection(candidate)"
                />
              </div>

              <validation-observer v-slot="{ }">
                <validate-form
                  :id="`name`"
                  type="text"
                  v-model="candidate.name"
                  :name="resource['hrvenue.createCandidate.Name']"
                  rules="required|min:2|validChar"
                  :placeholder="resource['hrvenue.candidateNamePlaceholder']"
                  @keypress="maxLengthCheck($event, 75, 'name', indexAt)"
                  @keyup="maxLengthCheck($event, 75, 'name', indexAt)"
                  @input="updateSelectedCandidate(candidate, indexAt)"
                  :classGroup="'touched'"
                >
                </validate-form>
              </validation-observer>

              <validation-observer v-slot="{ }">
                <validate-form
                  :id="`surname`"
                  :name="resource['hrvenue.createCandidate.Surname']"
                  v-model="candidate.surname"
                  type="text"
                  rules="validChar"
                  :placeholder="resource['hrvenue.candidateSurNamePlaceholder']"
                  @keypress="maxLengthCheck($event, 75, 'surname', indexAt)"
                  @keyup="maxLengthCheck($event, 75, 'surname', indexAt)"
                  @input="updateSelectedCandidate(candidate, indexAt)"
                  :classGroup="'touched'"
                >
                </validate-form>
              </validation-observer>

              <validation-observer v-slot="{ }">
                <validate-form
                  :id="`email`"
                  :name="resource['hrvenue.createCandidate.Email']"
                  v-model="candidate.email"
                  type="text"
                  rules="onlyEnglishLetters|required|min:10|max:300|emailRegex"
                  :placeholder="resource['hrvenue.candidateEmailPlaceholder']"
                  @keypress="maxLengthCheck($event, 300, 'email', indexAt)"
                  @keyup="maxLengthCheck($event, 300, 'email', indexAt)"
                  @input="updateSelectedCandidate(candidate, indexAt)"
                  :classGroup="'touched'"
                >
                </validate-form>
              </validation-observer>
              <div
                v-if="visibleCandidates.length > 1"
                @click="clickDelete(indexAt)"
                :id="`delete${indexAt}FormInput`"
                :name="`delete${indexAt}`"
                class="cursor-pointer delete-icon"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.2 3.80714C11.94 3.54714 11.52 3.54714 11.26 3.80714L7.99998 7.06047L4.73998 3.80047C4.47998 3.54047 4.05998 3.54047 3.79998 3.80047C3.53998 4.06047 3.53998 4.48047 3.79998 4.74047L7.05998 8.00047L3.79998 11.2605C3.53998 11.5205 3.53998 11.9405 3.79998 12.2005C4.05998 12.4605 4.47998 12.4605 4.73998 12.2005L7.99998 8.94047L11.26 12.2005C11.52 12.4605 11.94 12.4605 12.2 12.2005C12.46 11.9405 12.46 11.5205 12.2 11.2605L8.93998 8.00047L12.2 4.74047C12.4533 4.48714 12.4533 4.06047 12.2 3.80714Z" fill="#333333"/>
                </svg>
              </div>
              <div v-else class="delete-icon-empty">&nbsp;</div>
            </div>
          </div>
        </validation-observer>
        <div v-if="isLoadingMore" class="loading-indicator">
          <i class="icon-spinner icon-spin"></i>
          <span>{{ resource['candidateListScrollingLoading'] }}</span>
        </div>
        <div v-if="!isLoadingMore && visibleCandidates.length === 0" class="no-results-message">
          <span>{{resource['addCandidateModalSearchNoResults']}}</span>
        </div>

        <!-- End of list indicator -->
        <div v-if="allCandidatesLoaded && visibleCandidates.length > 0 && visibleCandidates.length > paginationConfig.pageSize"
            class="end-list-indicator">
          <span>{{resource['candidateListScrollingEnd']}}</span>
        </div>

        <!-- Selected candidates summary -->
      </div>
      <div class="excel-modal__footer">
        <div class="selected-summary">
          <span v-if="selectedCandidates.length > 0 && currentStep === 2"><i class="icon-info"></i>{{ `${selectedCandidates.length}/${candidate.candidates.length} ${resource['candidateListSelected']}`}}</span>
        </div>
        <div class="button-group">
          <b-button
            v-if="currentStep > 1 && totalSteps > 1"
            name="back"
            class="border-button-create"
            @click="backHandler"
          >
            <span>{{ resource['addCandidateModalBackBtn'] }}</span>
          </b-button>
          <b-button
            v-else
            name="cancel"
            class="border-button-create"
            @click="hiddenModal"
          >
            <span>{{ resource['addCandidateModalCancelBtn'] }}</span>
          </b-button>
          <b-button
            v-if="currentStep < totalSteps && totalSteps > 1"
            name="next"
            class="bg-button gap-2 d-flex align-items-center"
            :disabled="!selectedFile"
            @click="excelNextHandler"
          >
            <span>{{ resource['addCandidateModalNextBtn'] }}</span>
          </b-button>
          <b-button
            v-else
            name="add"
            class="bg-button gap-2 d-flex align-items-center"
            :disabled="buttonLoading"
            @click="submitHandler()"
          >
            <i
              v-if="buttonLoading"
              class="icon-spinner icon-spin"
              width="20"
              height="20"
            />
            <span>{{ resource['addCandidateSModalSubmitBtn'] }}</span>
          </b-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="excel-modal__body">
        <div class="excel-modal__success">
          <img class="sended-mail-icon" :src="require('@/assets/hrVenue/add-candidate-succes.svg')" />
          <h3>{{ sendedCandidates.length }} {{resource['addCandidateModalSuccessTitle']}}</h3>
          <div v-if="interviewType === 1">
            <span v-if="sendMail">{{resource['addCandidateModalExcelSuccessSendMailDescription']}}</span>
            <span v-else>{{resource['addCandidateModalExcelSuccessNotSendMailDescription']}}</span>
          </div>
        </div>
      </div>
      <div class="excel-modal__footer">
        <b-button
          name="add"
          class="bg-button d-flex align-items-center download-btn"
          @click="successPageHandler"
        >
          <span>
            {{resource['addCandidateModalDownloadExcelBtn']}}
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M11.9998 9.99935V11.9993H3.99984V9.99935H2.6665V11.9993C2.6665 12.7327 3.2665 13.3327 3.99984 13.3327H11.9998C12.7332 13.3327 13.3332 12.7327 13.3332 11.9993V9.99935H11.9998ZM11.3332 7.33268L10.3932 6.39268L8.6665 8.11268V2.66602H7.33317V8.11268L5.6065 6.39268L4.6665 7.33268L7.99984 10.666L11.3332 7.33268Z" fill="white"/>
          </svg>
          <!-- <span v-if="sendMail">{{resource['addCandidateModalBackListBtn']}}</span> -->
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { read, utils } from 'xlsx';
import ResourceManager from '@/services/resource.service';
import { showNotification } from '../../../static/helpers';
import DatePicker from '../../common/DatePicker.vue';

export default {
  name: 'excelModal',
  components: {
    DatePicker,
  },
  props: {
    candidate: { type: Object, required: true },
    dateRange: { type: Object, required: true },
    invalid: { type: Boolean, default: true },
    buttonLoading: { type: Boolean, default: false },
    currentStep: { type: Number, default: 0 },
    totalSteps: { type: Number, default: 0 },
    showSuccessStep: { type: Boolean, default: false },
    sendableCount: { type: Number, default: 0 },
    sendedCandidates: { type: Array, default: () => [] },
    unSendedCandidates: { type: Array, default: () => [] },
    totalSendedCount: { type: Number, default: 0 },
    interviewType: { type: Number, default: 1 },
  },
  data() {
    return {
      showDateModalError: false,
      showDatePicker: false,
      sendMail: true,
      datePickerValid: true,
      selectedFile: null,
      isDragging: false,
      fileError: null,
      allowedFileTypes: [
        'application/vnd.ms-excel', // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      ],
      notificationShowed: false,
      paginationConfig: {
        pageSize: 20,
        currentPage: 1,
        totalItems: 0,
      },
      displayedCandidates: [],
      isLoadingMore: false,
      allCandidatesLoaded: false,
      fileUploadLoading: true,
      fileUploadCompleted: false,
      searchTerm: '',
      selectedCandidates: [],
      showCandidateListErrorMessages: false,
      showDatePickerError: false,
      showDatePickerSaveError: false,
      showDatePickerSuccess: false,
      exampleExcellText: '',
      language: 'en-US',
      totalRows: 0,
      deleteOperation: false,
      localDateRange: { ...this.dateRange },
    };
  },
  created() {
    this.exampleExcellText = this.resource['hrvenue.createcandidate.dowloadLinkText']
      .replace('<b>', '<a href="/files/sampleExcel.xlsx">')
      .replace('</b>', '</a>');

    this.language = typeof ResourceManager.CurrentLang !== 'string' ? ResourceManager.CurrentLang.key : ResourceManager.CurrentLang;
  },
  mounted() {
    // Add scroll event listener to modal body
    this.$nextTick(() => {
      const modalBody = document.querySelector('.excel-modal__body');
      if (modalBody) {
        modalBody.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    // Remove event listener
    const modalBody = document.querySelector('.excel-modal__body');
    if (modalBody) {
      modalBody.removeEventListener('scroll', this.handleScroll);
    }
  },
  computed: {
    filteredCandidates() {
      if (!this.searchTerm) {
        return this.candidate.candidates;
      }

      const searchLower = this.searchTerm.toLowerCase();
      return this.candidate.candidates.filter((candidate) => (candidate.name && candidate.name.toLowerCase().includes(searchLower))
        || (candidate.surname && candidate.surname.toLowerCase().includes(searchLower))
        || (candidate.email && candidate.email.toLowerCase().includes(searchLower)));
    },
    visibleCandidates() {
      if (!this.searchTerm) {
        return this.displayedCandidates;
      }

      // When searching, show all matching candidates from the filtered set
      const pageSize = this.paginationConfig.pageSize;
      const currentPage = this.paginationConfig.currentPage;
      const startIndex = (currentPage - 1) * pageSize;
      return this.filteredCandidates.slice(startIndex, startIndex + pageSize);
    },
    isAllSelected() {
      if (this.visibleCandidates.length === 0) return false;
      return this.visibleCandidates.every((candidate) => this.isSelected(candidate));
    },
  },
  methods: {
    handleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
      if (this.showDatePicker) {
        this.showDatePickerError = false;
        this.showDatePickerSaveError = false;
        this.showDatePickerSuccess = false;
      }
    },
    excelNextHandler() {
      if (this.showDatePicker) {
        this.showDatePickerSaveError = true;
        this.showDatePickerSuccess = false;
        this.showDatePickerError = false;
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionSaveError,
          'error',
        );
        this.scrollToBottom();
        return;
      }
      if (!this.datePickerValid) {
        this.showDatePickerSaveError = false;
        this.showDatePickerSuccess = false;
        this.showDatePickerError = true;
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionError,
          'error',
        );
        this.scrollToBottom();
        return;
      }
      if (this.totalRows > this.sendableCount) {
        return;
      }
      if (this.selectedFile && this.datePickerValid) {
        if (!this.fileUploadCompleted) {
          this.fileUpload();
          setTimeout(() => {
            if (!this.fileError) {
              this.fileUploadLoading = true;
              this.$emit('next');
              this.showDatePickerError = false;
              this.showDatePickerSaveError = false;
              this.showDatePickerSuccess = false;
            }
          }, 500);
        } else {
          // eslint-disable-next-line no-lonely-if
          if (!this.fileError) {
            this.fileUploadLoading = true;
            this.$emit('next');
            this.showDatePickerError = false;
            this.showDatePickerSaveError = false;
            this.showDatePickerSuccess = false;
          }
        }
      }
    },
    backHandler() {
      this.$emit('prev');

      setTimeout(() => {
        this.allCandidatesLoaded = false;
        this.selectedCandidates = [];
        this.displayedCandidates = [];
        this.paginationConfig.currentPage = 1;
        this.paginationConfig.totalItems = 0;
        this.showCandidateListErrorMessages = false;
        this.fileUploadLoading = true;

        this.$emit('updateCandidate', {
          candidates: [{
            name: '',
            surname: '',
            email: '',
          }],
        });

        setTimeout(() => {
          this.fileUpload();
        }, 50);
      }, 50);
    },
    submitHandler() {
      const hasInvalidSelectedCandidate = this.selectedCandidates.some((selectedCandidate) => !selectedCandidate.isValid);

      if (hasInvalidSelectedCandidate || this.selectedCandidates.length === 0) {
        this.scrollToTop();
        this.showCandidateListErrorMessages = true;
        return;
      }

      if (!this.buttonLoading || this.datePickerValid) {
        const values = {
          dateRange: this.localDateRange,
          sendMail: this.sendMail,
          file: this.selectedFile,
          selectedCandidates: this.selectedCandidates,
        };
        this.$emit('submit', values);
      }
    },
    handleUpdate(value) {
      this.localDateRange = { ...value };
      this.$emit('update:dateRange', this.localDateRange);
    },
    shownModal() {
      //
    },

    hiddenModal() {
      this.$emit('onHide');
      this.localDateRange = {
        startDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
        daysCount: 0,
        startTime: null,
        endTime: null,
        selectedDuration: '7',
      };
      this.showDateModalError = false;
      this.showDatePicker = false;
      this.sendMail = true;
      this.datePickerValid = true;
      this.selectedFile = null;
      this.fileError = null;
      this.selectedCandidates = [];
    },
    validateDateInputs() {
      const {
        startDate, endDate, startTime, endTime, selectedDuration,
      } = this.localDateRange;
      const isValid = [startDate, endDate, startTime, endTime, selectedDuration].every(Boolean);

      this.showDateModalError = !isValid;
      this.datePickerValid = isValid;
      this.showDatePickerSuccess = isValid;
      this.showDatePickerError = !isValid;
      this.showDatePickerSaveError = false;
      if (isValid) {
        showNotification(
          this.resource['Label.Success'],
          this.resource.ScheduleAreaSelectionSuccess,
          'success',
        );
      } else {
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionError,
          'error',
        );
      }
      this.scrollToBottom();

      return isValid;
    },
    checkValidateRule(candidate) {
      this.$emit('onValidateField', candidate);
    },
    setWhichInput(InpEl, value, indexAt) {
      if (InpEl === 'name') {
        this.candidate.candidates[indexAt].name = value;
      } else if (InpEl === 'surname') {
        this.candidate.candidates[indexAt].surname = value;
      } else {
        this.candidate.candidates[indexAt].email = value;
      }
    },
    maxLengthCheck(event, maxLength, inp, indexAt) {
      const value = event.target.value;
      if (!maxLength || String(value).length <= maxLength) {
        this.setWhichInput(inp, value, indexAt);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength), indexAt);
        event.stopPropagation();
      }

      const candidate = this.candidate.candidates[indexAt];
      if (candidate && candidate._tempId) {
        this.updateSelectedCandidate(candidate, indexAt);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    onDragOver() {
      this.isDragging = true;
    },

    onDragLeave() {
      this.isDragging = false;
    },

    onFileDrop(event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.validateAndSetFile(files[0]);
      }
    },

    onFileSelected(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.validateAndSetFile(files[0]);
      }
    },

    validateAndSetFile(file) {
      this.fileError = null;

      // Check file extension
      const fileName = file.name.toLowerCase();
      const isExcel = fileName.endsWith('.xlsx') || fileName.endsWith('.xls');

      if (!isExcel) {
        this.fileError = this.resource.addCandidateModalExcelFileTypeError;
        return;
      }

      // Check file size (limit to 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.fileError = this.resource.addCandidateModalExcelFileSizeError;
        return;
      }

      this.selectedFile = file;
    },

    removeFile() {
      // TODO: modal eklenecek
      this.selectedFile = null;
      this.fileError = null;
      this.$refs.fileInput.value = '';
      this.fileUploadCompleted = false;
      this.displayedCandidates = [];
      this.selectedCandidates = [];
      this.$emit('updateCandidate', {
        candidates: [{
          name: '',
          surname: '',
          email: '',
        }],
      });
      this.totalRows = 0;
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / (k ** i)).toFixed(2))} ${sizes[i]}`;
    },
    formatFileName(fileName) {
      // latin characters problem fix
      // Replace non-latin characters with their latin equivalents
      const latinFileName = fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return latinFileName;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.excel-modal__body');
        if (modalBody) {
          modalBody.scrollTo({
            top: modalBody.scrollHeight,
            behavior: 'smooth',
          });
        }
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.excel-modal__body');
        if (modalBody) {
          modalBody.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      });
    },
    fileUpload() {
      if (this.selectedFile) {
        this.showCandidateListErrorMessages = false;
        this.fileUploadLoading = true;
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const rows = utils.sheet_to_json(worksheet, {
            header: 1, raw: false, blankrows: false, skipHidden: true,
          });
          if (rows[0][0] !== 'Name' || rows[0][1] !== 'Surname' || rows[0][2] !== 'Email') {
            this.fileError = this.resource['Label.DifferentExcelFileError'];
            return showNotification(
              this.resource['Label.Error'],
              this.resource['Label.DifferentExcelFileError'],
              'error',
            );
          }
          this.totalRows = rows.slice(1).length - 1;

          if (this.totalRows > this.sendableCount) {
            this.fileError = this.resource['candidateDetail.candidateNumberExceedError'];
            return showNotification(
              this.resource['Label.Error'],
              this.resource['candidateDetail.candidateNumberExceedError'],
              'error',
            );
          }

          rows.slice(1).forEach((row) => {
            const unifiedId = row[3] && row[3].startsWith('æpbæ-') ? row[3].replace('æpbæ-', '') : null;

            const newRow = {
              name: row[0],
              surname: row[1],
              email: row[2],
              unifiedId,
              unifiedIntegrationTypeId: unifiedId ? '825FD80875ADDE0B' : null,
              key: 'uploaded',
            };
            const isValid = this.validateFields(newRow);
            this.createNewInterViewer({ ...newRow, isValid });
          });
          setTimeout(() => {
            this.restoreValidationStates();
          }, 100);
          const groupedData = this.groupBy();
          let hasErrorItems = [];
          if (groupedData.false) {
            this.showCandidateListErrorMessages = true;
            hasErrorItems = [...groupedData.false];
          }
          const hasSuccessItems = groupedData.true ? [...groupedData.true] : [];
          if (hasErrorItems.length > 0 || hasSuccessItems.length > 0) {
            this.candidate.candidates = [
              ...this.candidate.candidates.filter((candidate) => (!candidate.key) && (candidate.name || candidate.surname || candidate.email)),
              ...hasErrorItems,
              ...hasSuccessItems,
            ];
          } else {
            this.selectedFile = null;

            showNotification(
              this.resource['Label.Error'],
              this.resource['Label.EmptyExcelFileError'], // Dosya boş olmamalı,
              'error',
            );
          }
          this.initPagination();

          // Select all after file is loaded and candidates are displayed
          this.$nextTick(() => {
            this.selectAllCandidates();
          });
        };
        reader.onloadend = () => {
          this.fileUploadCompleted = true;
          this.fileUploadLoading = false;
        };
        reader.readAsBinaryString(this.selectedFile);
      }
    },
    validateFields(obj) {
      if (obj.name === undefined || obj.email === undefined) {
        obj.name = obj.name !== undefined ? obj.name?.slice(0, 75) : obj.name;
        // obj.surname = obj.surname !== undefined ? obj.surname?.slice(0, 75) : obj.surname;
        return false;
      }
      const nameMatch = obj.name?.match(/[a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g);
      // const surnameMatch = obj.surname?.match(/[a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g);

      obj.name = nameMatch ? nameMatch.join('')?.slice(0, 75) : '';
      // obj.surname = surnameMatch ? surnameMatch.join('')?.slice(0, 75) : '';
      // eslint-disable-next-line no-useless-escape
      const validEmail = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/.test(obj.email);
      const validLength = (obj.name?.length >= 2 && obj.email?.length >= 10 && obj.email?.length <= 300);
      const validName = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(obj.name);
      // const validSurname = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(obj.surname);
      if (validEmail && validLength && validName) {
        return true;
      }
      return false;
    },
    createNewInterViewer(candidateObj) {
      if (candidateObj) {
        if (!candidateObj.name && !candidateObj.surname && !candidateObj.email) {
          return;
        }
        const isValid = this.validateFields(candidateObj);
        const _tempId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newCandidate = { ...candidateObj, isValid, _tempId };
        const lastChildCandidate = this.candidate.candidates.length - 1;
        const lastChildCandidateName = this.candidate.candidates[lastChildCandidate].name;
        const lastChildCandidateSurname = this.candidate.candidates[lastChildCandidate].surname;
        const lastChildCandidateEmail = this.candidate.candidates[lastChildCandidate].email;
        if (lastChildCandidateName === undefined && lastChildCandidateSurname === undefined && lastChildCandidateEmail === undefined) {
          // this.candidate.candidates[lastChildCandidate] = { ...this.candidate.candidates[lastChildCandidate], ...newCandidate };
          this.candidate.candidates.pop();
          this.candidate.candidates.push(newCandidate);
        } else {
          this.candidate.candidates.push(newCandidate);
        }
      } else {
        this.candidate.candidates.push({ });
      }
      setTimeout(() => {
        this.restoreValidationStates();
      }, 100);
    },
    groupBy() {
      return this.candidate.candidates.reduce((r, a) => {
        r[a.isValid] = r[a.isValid] || [];
        r[a.isValid].push(a);
        return r;
      }, Object.create(null));
    },
    initPagination() {
      setTimeout(() => {
        const candidates = this.searchTerm ? this.filteredCandidates : this.candidate.candidates;
        this.paginationConfig.totalItems = candidates.length;
        this.paginationConfig.currentPage = 1;
        this.displayedCandidates = candidates.slice(0, this.paginationConfig.pageSize);
        this.allCandidatesLoaded = this.displayedCandidates.length >= candidates.length;

        // Update selected candidates when initialized
        this.updateSelectedCandidatesAfterChange();

        setTimeout(() => {
          this.restoreValidationStates();
          this.fileUploadLoading = false;
        }, 150);
      }, 100);
    },
    loadMoreCandidates() {
      if (this.isLoadingMore || this.allCandidatesLoaded) return;

      this.isLoadingMore = true;

      setTimeout(() => {
        const candidates = this.searchTerm ? this.filteredCandidates : this.candidate.candidates;
        const nextPage = this.paginationConfig.currentPage + 1;
        const startIndex = this.paginationConfig.pageSize * (nextPage - 1);
        const endIndex = startIndex + this.paginationConfig.pageSize;

        const newItems = candidates.slice(startIndex, endIndex);

        if (newItems.length > 0) {
          this.displayedCandidates = [...this.displayedCandidates, ...newItems];
          this.paginationConfig.currentPage = nextPage;
          this.allCandidatesLoaded = endIndex >= candidates.length;
        } else {
          this.allCandidatesLoaded = true;
        }

        this.isLoadingMore = false;
      }, 50);
    },
    handleScroll(event) {
      if (this.currentStep !== 2) return;

      const container = event.target;
      const scrollPosition = container.scrollTop + container.clientHeight;
      const scrollHeight = container.scrollHeight;

      // Load more when user scrolls to bottom
      if (scrollHeight - scrollPosition < 100) {
        this.loadMoreCandidates();
      }
    },
    clickDelete(indexAt) {
      if (this.deleteOperation) {
        return;
      }
      this.deleteOperation = true;
      const candidateToDelete = this.visibleCandidates[indexAt];
      // Find its index in the original full list
      const actualIndex = this.candidate.candidates.findIndex((c) => c._tempId === candidateToDelete._tempId
        || (c.email === candidateToDelete.email
        && c.name === candidateToDelete.name
        && c.surname === candidateToDelete.surname));

      // Remove from selected candidates if it was selected
      if (this.isSelected(candidateToDelete)) {
        if (candidateToDelete._tempId) {
          this.selectedCandidates = this.selectedCandidates.filter((sc) => sc._tempId !== candidateToDelete._tempId);
        }
      }

      // Create updated candidates list
      const updatedCandidates = [
        ...this.candidate.candidates.slice(0, actualIndex),
        ...this.candidate.candidates.slice(actualIndex + 1),
      ];

      // Emit the update with a copy to prevent reference issues
      this.$emit('updateCandidate', {
        candidates: JSON.parse(JSON.stringify(updatedCandidates)),
      });

      // Handle pagination and display updates
      if (this.searchTerm) {
        // When searching, just refresh the filtered list
        this.paginationConfig.totalItems = this.filteredCandidates.length - 1;
        const startIndex = (this.paginationConfig.currentPage - 1) * this.paginationConfig.pageSize;
        const endIndex = startIndex + this.paginationConfig.pageSize;
        this.displayedCandidates = this.filteredCandidates.slice(startIndex, endIndex);
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.displayedCandidates.length === 1 && this.paginationConfig.currentPage > 1) {
          this.paginationConfig.currentPage -= 1;

          const startIndex = this.paginationConfig.pageSize * (this.paginationConfig.currentPage - 1);
          const endIndex = startIndex + this.paginationConfig.pageSize;
          this.displayedCandidates = this.candidate.candidates.slice(startIndex, endIndex);
        } else {
          this.displayedCandidates.splice(indexAt, 1);

          if (this.displayedCandidates.length < this.paginationConfig.pageSize
          && this.candidate.candidates.length > this.paginationConfig.pageSize * this.paginationConfig.currentPage) {
            const nextItemIndex = this.paginationConfig.pageSize * this.paginationConfig.currentPage;
            if (this.candidate.candidates[nextItemIndex]) {
              this.displayedCandidates.push(this.candidate.candidates[nextItemIndex]);
            }
          }
        }
      }
      // Move this inside the nextTick to ensure it runs after DOM updates
      this.$nextTick(() => {
        this.updateSelectedCandidatesAfterChange();
        this.restoreValidationStates();
      });
      setTimeout(() => {
        this.deleteOperation = false;
      }, 150);
    },

    // Selection methods
    isSelected(candidate) {
      if (!candidate) return false;

      return this.selectedCandidates.some((sc) => sc._tempId === candidate._tempId);
    },

    toggleSelection(candidate) {
      if (!candidate) return;

      if (this.isSelected(candidate)) {
        if (candidate._tempId) {
          this.selectedCandidates = this.selectedCandidates.filter((sc) => sc._tempId !== candidate._tempId);
        }
      } else {
        // Add a deep clone of the candidate to the selection
        const candidateToAdd = JSON.parse(JSON.stringify(candidate));
        candidateToAdd.isValid = this.validateFields({
          name: candidateToAdd.name,
          surname: candidateToAdd.surname,
          email: candidateToAdd.email,
        });
        this.selectedCandidates.push(candidateToAdd);
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedCandidates = [];
      } else {
        this.selectAllCandidates();
      }
    },

    selectAllCandidates() {
      if (this.candidate.candidates && this.candidate.candidates.length > 0) {
        this.selectedCandidates = [];

        this.candidate.candidates.forEach((candidate) => {
          const candidateToAdd = JSON.parse(JSON.stringify(candidate));
          // Ensure isValid property is set correctly for each candidate
          candidateToAdd.isValid = this.validateFields({
            name: candidateToAdd.name,
            surname: candidateToAdd.surname,
            email: candidateToAdd.email,
          });
          this.selectedCandidates.push(candidateToAdd);
        });
      }
    },

    updateSelectedCandidatesAfterChange() {
      const validSelectedCandidates = [];

      this.selectedCandidates.forEach((selected) => {
        const stillExists = this.candidate.candidates.some((candidate) => selected._tempId === candidate._tempId);

        if (stillExists) {
          validSelectedCandidates.push(selected);
        }
      });

      this.selectedCandidates = validSelectedCandidates;
    },
    restoreValidationStates() {
      setTimeout(() => {
        document.querySelectorAll('.interview-input-group').forEach((el) => {
          const formGroups = el.querySelectorAll('.form-group');
          formGroups.forEach((inp) => {
            inp.classList.remove('untouched');
            inp.classList.add('touched');
          });
        });
      }, 50);
    },
    successPageHandler() {
      this.$emit('downloadExcel');
    },
    updateSelectedCandidate(candidate) {
      this.checkValidateRule(candidate);

      // Find the candidate in the selectedCandidates array by _tempId
      if (candidate._tempId) {
        const selectedIndex = this.selectedCandidates.findIndex(
          (sc) => sc._tempId === candidate._tempId,
        );

        if (selectedIndex !== -1) {
          // Update the selected candidate with the new values
          this.selectedCandidates[selectedIndex] = {
            ...this.selectedCandidates[selectedIndex],
            name: candidate.name,
            surname: candidate.surname,
            email: candidate.email,
            isValid: this.validateFields({
              name: candidate.name,
              surname: candidate.surname,
              email: candidate.email,
            }),
          };
        }
      }
    },
  },
  watch: {
    showDatePicker(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.scrollToBottom();
        }, 250);
      }
    },
    dateRange: {
      handler(newVal) {
        this.localDateRange = { ...newVal };
      },
      deep: true,
    },
    currentStep(newVal) {
      if (newVal === 2 && this.candidate.candidates.length > 0) {
        this.fileUploadLoading = true;

        // Delay initialization to let the UI transition complete
        setTimeout(() => {
          this.initPagination();
          this.restoreValidationStates();

          // Select all candidates after a delay
          setTimeout(() => {
            this.selectAllCandidates();
          }, 150);
        }, 150);
      }
    },
    searchTerm(newVal) {
      // Reset pagination and update displayed candidates when search term changes
      this.paginationConfig.currentPage = 1;
      const candidates = newVal ? this.filteredCandidates : this.candidate.candidates;
      this.displayedCandidates = candidates.slice(0, this.paginationConfig.pageSize);
      this.allCandidatesLoaded = this.displayedCandidates.length >= candidates.length;

      this.$nextTick(() => {
        this.restoreValidationStates();
      });
    },
    'candidate.candidates': {
      handler(newValue) {
        this.updateSelectedCandidatesAfterChange();

        // If we're on step 2 and this is the first time candidates are loaded,
        // select them all
        if (this.currentStep === 2
            && newValue
            && newValue.length > 0
            && this.selectedCandidates.length === 0) {
          this.$nextTick(() => {
            this.selectAllCandidates();
          });
        }

        // Update validation state of selected candidates
        if (this.selectedCandidates.length > 0) {
          this.selectedCandidates.forEach((selected, index) => {
            const matchingCandidate = newValue.find((c) => c._tempId === selected._tempId);
            if (matchingCandidate) {
              this.selectedCandidates[index].isValid = this.validateFields({
                name: matchingCandidate.name,
                surname: matchingCandidate.surname,
                email: matchingCandidate.email,
              });
            }
          });
        }

        this.$nextTick(() => {
          this.restoreValidationStates();
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.interview-input-header {
  display: flex;
  align-items: center;
  padding: 4px 0 4px 8px;
  gap: 4px;
  border-radius: 4px;
  background: #EEE;
  width: fit-content;

  .input-columns {
    display: flex;
    align-items: center;
    gap: var(--Padding-Medium, 12px);
  }

  span {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    width: 197px;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      width: 76px;
    }
  }

  .checkbox-column {
    width: 20px;
  }
}

.candidate-checkbox {
  display: flex;
  align-items: center;
  width: 16px;
  margin-right: 0px;
  margin-left: 8px;
}

.select-all-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.selected-summary {
  display: flex;
  align-items: center;
  gap: 2px;

  span {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }

  i {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-size: 16px;
  }
}

.interview-input-group {
  display: flex;
  align-items: center;
}

.excel-modal__info {
  margin-bottom: 16px;

  span {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    ::v-deep a {
      color: #FF8D06 !important;
      text-decoration: none;
    }
  }

}

.excel-modal__sticky-header {
  padding-top: 16px;
  padding-bottom: 4px;
  background: #FFF;
  position: sticky;
  top: 0;
  z-index: 2;
}

.candidates-list {
  padding-top: 8px;
}

.schedule-area {
  width: 100%;
  display: flex;
  margin-top: 24px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
  background: var(--Background-Colors-Bright-Gray, #fafafa);

  &__divider {
    width: 100%;
    height: 1px;
    background: var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Padding-Small, 4px);
    align-self: stretch;

    h4 {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Subtitle/3 - Medium */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    span {
      color: var(--Text-Colors-Secondary-Gray-Text, #878787);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }

  &__preview {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    width: 100%;

    p {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Subtitle/3 - Medium */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    button {
      width: 100%;
      display: flex;
      padding: var(--Padding-Regular, 8px);
      align-items: center;
      justify-content: space-between;
      gap: var(--Padding-Small, 4px);
      border-radius: 4px;
      border: 1px solid var(--Stroke-Colors-Tertiary-Gray-Stroke, #e5e5e5);
      background: var(--Background-Colors-White, #fff);

      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      text-overflow: ellipsis;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        height: auto;
      }

      span {
        color: var(--Text-Colors-Primary-Gray-Text, #ff8d06);
        font-feature-settings: "liga" off, "clig" off;
        text-overflow: ellipsis;
        /* Typography/Body/3 - Regular */
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }
  }

  ::v-deep .custom-control-label {
    color: #333 !important;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
    padding-top: 2px !important;
  }
}
::v-deep {
  .form-group label {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: "liga" off, "clig" off;
    /* Typography/Subtitle/3 - Medium */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  .form-control {
    display: flex;
    padding: var(--Padding-Regular, 8px);
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #e5e5e5 !important;
    background: #fff;
    box-shadow: none !important;
    color: #333;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    &:focus {
      outline: none;
      border-color: #FF8D06 !important;
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
    }
  }
  .form-control-feedback {
    display: none !important;
  }
  .untouched {
    &.has-danger .form-control {
      border-color: #e5e5e5 !important;
      color: #333 !important;
      box-shadow: none !important;
    }
  }

  .checkbox-candidate {
    .custom-control-label {
      cursor: pointer;
      &:hover {
        &::after {
          background: #FFE9CE;
        }
      }
      &::after {
        border: 1px solid #333;
        border-radius: 2px;
      }
      &::before {
        border-color: transparent !important;
        outline: none;
        box-shadow: none;
        width: 16px !important;
        height: 16px !important;
      }
    }
    .custom-control-input {
      cursor: pointer;
      &:focus {
        border-color: transparent !important;
      }
      &:checked {
        & ~ .custom-control-label {
          &::before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -25px;
            border-radius: 2px;
          }
          &::after {
            display: none !important;
          }
        }
      }
    }
  }

  .error-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #F2B5B5);
    background: var(--Background-Colors-Light-Red, #F8DADA);

    span {
      color: var(--Text-Colors-Red-Text, #631212);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }

    i {
      font-size: 20px;
    }
  }

  .success-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #B6EAC9);
    background: var(--Background-Colors-Light-Red, #DBF4E4);
    margin-top: 16px;

    span {
      color: var(--Text-Colors-Red-Text, #19552E);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }
  }
}
.excel-upload-container {
  margin-bottom: 8px;
}

.excel-dropzone {
  position: relative;
  width: 100%;
  min-height: 152px;
  border: 1px dashed #e5e5e5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  transition: all 0.3s ease;
  background-color: #fafafa;
  cursor: pointer;

  &.drag-over {
    background-color: #FFF6E5;
    border-color: #FF8D06;
  }

  &.has-file {
    background-color: #FFF;
    border-color: #E5E5E5;
    border-style: solid;
    padding: 0;
    min-height: auto;
  }

  &.is-invalid {
    background-color: #fafafa;
    border-color: #DE4747;
  }
}

.drag-over {
  .upload-text {
    h3 {
      color: #FF8D06 !important;
    }
  }
}

.file-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .upload-text {
    display: flex;
    align-items: center;
    gap:4px;

    h3 {
      color: #333333;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      margin: 0;
    }
  }
}

.btn-select-file {
  display: inline-flex;
  background-color: transparent;
  padding: 0;
  color: #ff8d06;
  border: none;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  height: auto;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
}

.selected-file {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;

  .file-icon {
    flex-shrink: 0;
    display: flex;
    padding: 16px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 7px 0px 0px 7px;
    border-right: 1px solid var(--Stroke-Colors-Gray-Stroke, #E5E5E5);
    background: var(--Background-Colors-Light-Green, #DBF4E4);

    span {
      color: var(--Text-Colors-Green-Text, #19552E);
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
    }
  }

  .file-details {
    padding: 12px 0;
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .file-name {
      margin: 0;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
    }

    .file-size {
      margin: 0;
      color: var(--Text-Colors-Secondary-Text-Color, #989898);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .btn-remove-file {
    padding: 0 6px 0 0;
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    i {
      color: #333;
      font-size: 20px;
    }
  }
}

.error-message {
  color: #DE4747 !important;
  font-family: Roboto;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  text-align: left !important;
  margin: 0 !important;
}
.info-message {
  color: #878787 !important;
  font-family: Roboto;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  text-align: left !important;
  margin: 0 !important;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  color: #858585;

  i {
    font-size: 18px;
  }
}

.end-list-indicator {
  text-align: center;
  padding: 16px;
  color: #858585;
  font-size: 14px;
}

.delete-icon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 1px solid #D4D4D4;
  background: transparent;
  transition: all 0.3s ease;

  &:hover {
    background: #EEE;
  }
}
.delete-icon-empty {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  justify-content: center;
  align-items: center;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    flex-direction: column;
  }
}

.search-info {
  color: #878787;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.search-input-wrapper {
  position: relative;
  width: 250px;
}

.search-input {
  width: 100%;
  padding: 8px 36px 8px 12px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #FF8D06;
    box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
  }

  &::placeholder {
    color: #878787;
  }
}

.search-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.no-results-message {
  text-align: center;
  padding: 24px 16px;
  color: #878787;
  font-family: Roboto;
  font-size: 14px;
  font-style: italic;
}
</style>
